/**
 * connected-handlers-context.js
 */

import React, { createContext } from 'react';
import { UserContext } from 'contexts/user/user-context';


export const ConnectedHandlersContext = createContext();


export const ConnectedHandlersProvider = (props) => {
  const {
    handlers,
    managedHandlerIds,
    children
  } = props;
  const { user } = React.useContext(UserContext)


  // PUBLIC INTERFACE CONTAINER
  const [publicState] = React.useState({
    allHandlers: handlers,
    handlers: handlers.filter(h => h.id !== user.id),
    managedHandlerIds,
  });

  
  return (<>
    <ConnectedHandlersContext.Provider value={publicState}>
      {children}
    </ConnectedHandlersContext.Provider>
  </>);
}